import React, { useState } from 'react';
import { useShop } from '../context/ShopContext';
import { 
  MessageCircle, 
  X, 
  Sparkles, 
  Send, 
  PhoneCall, 
  Calculator, 
  ShieldCheck, 
  UserCheck 
} from 'lucide-react';

export default function JewelCasaChatWidget() {
  const { 
    isChatWidgetOpen, 
    setIsChatWidgetOpen, 
    setIsWastageModalOpen, 
    storeSettings,
    addToast 
  } = useShop();

  const [inputMsg, setInputMsg] = useState('');

  const phone = (storeSettings?.phone || storeSettings?.whatsapp || '919876543210').replace(/[^0-9]/g, '');

  const sendQuickMsg = (customText) => {
    const textToSend = customText || inputMsg || 'Hello ML Jewellers, I would like to inquire about your jewellery collections and live rates.';
    const url = `https://wa.me/${phone}?text=${encodeURIComponent(textToSend)}`;
    window.open(url, '_blank');
    setIsChatWidgetOpen(false);
    setInputMsg('');
    addToast('Connecting you with Senior Jewellery Specialist on WhatsApp...', 'success');
  };

  return (
    <>
      {/* Floating Circular CHAT Trigger Button (JewelCasa Signature) */}
      <div 
        className="jewelcasa-chat-container"
        style={{
        position: 'fixed',
        bottom: '85px',
        right: '20px',
        zIndex: 950,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-end',
        gap: '6px'
      }}>
        {/* Floating Bubble */}
        <button
          onClick={() => setIsChatWidgetOpen(!isChatWidgetOpen)}
          aria-label="Jewellery Specialist Chat"
          style={{
            height: '46px',
            padding: '0 15px',
            borderRadius: '999px',
            background: 'linear-gradient(135deg, #010f1c 0%, #1e1b2e 100%)',
            border: '1.5px solid var(--gold-400)',
            color: '#fff',
            boxShadow: '0 8px 24px rgba(0, 0, 0, 0.5), 0 0 16px rgba(212, 175, 55, 0.3)',
            display: 'flex',
            alignItems: 'center',
            gap: '7px',
            cursor: 'pointer',
            transition: 'transform 0.25s cubic-bezier(0.34, 1.56, 0.64, 1)',
            transform: isChatWidgetOpen ? 'scale(0.95)' : 'scale(1)'
          }}
          className="jewelcasa-chat-btn"
        >
          <span style={{
            position: 'relative',
            display: 'inline-flex'
          }}>
            <MessageCircle size={19} color="var(--gold-400)" />
            <span style={{
              position: 'absolute',
              top: '-2px',
              right: '-2px',
              width: '8px',
              height: '8px',
              borderRadius: '50%',
              backgroundColor: '#10b981',
              boxShadow: '0 0 6px #10b981'
            }} />
          </span>

          <span 
            className="chat-btn-label"
            style={{
            fontFamily: 'var(--font-display), sans-serif',
            fontSize: '0.78rem',
            fontWeight: 800,
            letterSpacing: '0.08em',
            color: 'var(--gold-300)'
          }}>
            CHAT
          </span>
        </button>
      </div>

      <style>{`
        @media (max-width: 768px) {
          .jewelcasa-chat-container {
            bottom: 70px !important;
            left: 14px !important;
            right: auto !important;
            align-items: flex-start !important;
          }
          .jewelcasa-chat-btn {
            height: 42px !important;
            padding: 0 12px !important;
            gap: 6px !important;
            box-shadow: 0 4px 14px rgba(0, 0, 0, 0.4) !important;
          }
          .chat-btn-label {
            font-size: 0.72rem !important;
          }
          .jewelcasa-popover-box {
            left: 12px !important;
            right: auto !important;
            bottom: 124px !important;
            max-width: calc(100vw - 24px) !important;
            width: 320px !important;
          }
        }
      `}</style>

      {/* Concierge Popover Window */}
      {isChatWidgetOpen && (
        <div 
          className="jewelcasa-popover-box"
          style={{
            position: 'fixed',
            bottom: '145px',
            right: '20px',
            width: '320px',
            background: 'linear-gradient(145deg, #14131f 0%, #0c0b12 100%)',
            border: '1px solid var(--border-gold)',
            borderRadius: 'var(--radius-md)',
            boxShadow: '0 20px 50px rgba(0,0,0,0.8), 0 0 25px rgba(212,175,55,0.2)',
            zIndex: 960,
            color: '#fff',
            overflow: 'hidden',
            animation: 'fadeInUp 0.3s ease-out'
          }}
        >
          {/* Header */}
          <div style={{
            padding: '0.85rem 1rem',
            background: 'rgba(212, 175, 55, 0.1)',
            borderBottom: '1px solid rgba(212, 175, 55, 0.2)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between'
          }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
              <div style={{
                width: '32px',
                height: '32px',
                borderRadius: '50%',
                background: 'var(--gold-gradient)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                color: '#000'
              }}>
                <UserCheck size={18} />
              </div>
              <div>
                <div style={{ fontSize: '0.84rem', fontWeight: 700, color: '#fff' }}>
                  Jewellery Specialist
                </div>
                <div style={{ fontSize: '0.68rem', color: '#34d399', display: 'flex', alignItems: 'center', gap: '3px' }}>
                  <span style={{ width: '6px', height: '6px', borderRadius: '50%', background: '#10b981' }} />
                  Online • Instant Reply
                </div>
              </div>
            </div>

            <button
              onClick={() => setIsChatWidgetOpen(false)}
              style={{
                background: 'transparent',
                border: 'none',
                color: 'var(--text-secondary)',
                cursor: 'pointer',
                padding: '4px'
              }}
            >
              <X size={16} />
            </button>
          </div>

          {/* Quick Prompts */}
          <div style={{ padding: '0.85rem', display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
            <div style={{ fontSize: '0.74rem', color: 'var(--text-secondary)', marginBottom: '2px' }}>
              How can we assist you today?
            </div>

            {[
              {
                text: '💎 Get Today\'s Live Gold Rate & Quote',
                msg: 'Hello ML Jewellers, please share today\'s live gold rate card and best making charge quote.'
              },
              {
                text: '👑 Custom Bridal & Kitchenware Inquiry',
                msg: 'Hello ML Jewellers, I want to inquire about custom bridal sets and royal kitchenware.'
              },
              {
                text: '✨ Custom CAD / 3D Jewellery Making',
                msg: 'Hello, I have a custom jewellery design I want to get manufactured. Can I share photos?'
              }
            ].map((q, i) => (
              <button
                key={i}
                onClick={() => sendQuickMsg(q.msg)}
                style={{
                  background: 'rgba(255, 255, 255, 0.04)',
                  border: '1px solid rgba(255, 255, 255, 0.08)',
                  borderRadius: '6px',
                  padding: '0.55rem 0.75rem',
                  color: '#e2e8f0',
                  fontSize: '0.75rem',
                  textAlign: 'left',
                  cursor: 'pointer',
                  transition: 'all 0.2s',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between'
                }}
              >
                <span>{q.text}</span>
              </button>
            ))}
          </div>

          {/* Direct Input */}
          <div style={{
            padding: '0.75rem 0.85rem',
            borderTop: '1px solid rgba(255,255,255,0.08)',
            display: 'flex',
            alignItems: 'center',
            gap: '0.4rem',
            background: 'rgba(0,0,0,0.3)'
          }}>
            <input
              type="text"
              placeholder="Type your message..."
              value={inputMsg}
              onChange={(e) => setInputMsg(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === 'Enter') sendQuickMsg();
              }}
              style={{
                flex: 1,
                height: '34px',
                lineHeight: '34px',
                background: 'rgba(255,255,255,0.06)',
                border: '1px solid rgba(255,255,255,0.1)',
                borderRadius: '4px',
                padding: '0 8px',
                fontSize: '0.78rem',
                color: '#fff'
              }}
            />
            <button
              onClick={() => sendQuickMsg()}
              style={{
                width: '34px',
                height: '34px',
                borderRadius: '4px',
                background: '#25D366',
                border: 'none',
                color: '#fff',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                cursor: 'pointer'
              }}
            >
              <Send size={15} />
            </button>
          </div>

        </div>
      )}
    </>
  );
}
